import React from "react";
import { graphql, useFragment } from "react-relay";

import { MeetingContent } from "~/meetings/MeetingContent";
import { MeetingPhaseContextProvider } from "~/stream/MeetingPhaseContext";

import type { Notes_note$key } from "~/__generated__/Notes_note.graphql";
import type { Notes_viewer$key } from "~/__generated__/Notes_viewer.graphql";

import styles from "./Notes.module.css";

const notesViewerFragment = graphql`
	fragment Notes_viewer on Viewer {
		...MeetingPhaseContext_viewer
		...MeetingContent_viewer
	}
`;

const notesNoteFragment = graphql`
	fragment Notes_note on Note {
		id
		stream {
			id
			type
		}

		meetingRecordings {
			...MeetingContent_meetingRecording @relay(mask: false)
		}

		...MeetingPhaseContext_note
		...MeetingContent_note
	}
`;

export default function Notes({
	viewer: viewerKey,
	note: noteKey,
}: {
	viewer: Notes_viewer$key;
	note: Notes_note$key;
}) {
	// TODO: preload this query
	const viewer = useFragment(notesViewerFragment, viewerKey);
	const note = useFragment(notesNoteFragment, noteKey);

	return (
		<div className={styles.notesContainer}>
			<MeetingPhaseContextProvider viewer={viewer} note={note}>
				<MeetingContent
					viewer={viewer}
					note={note}
					recordings={note.meetingRecordings ?? []}
					isNarrow
					openedTab="agenda"
				/>
			</MeetingPhaseContextProvider>
		</div>
	);
}
